/**
 * Specifically extracts messages from the capture.warn_case structure
 * This is optimized for the specific data structure from diroStatusData
 * 
 * @param {Object} buttonDetails - The button details object containing capture data
 * @returns {Array} Array of message values from warn_case items
 */
export const extractWarnCaseMessages = (buttonDetails) => {
    try {
        // Direct path to warn_case messages for better performance
        if (buttonDetails?.capture?.warn_case && Array.isArray(buttonDetails.capture.warn_case)) {
            return buttonDetails.capture.warn_case
                .map(item => item.message)
                .filter(message => message && typeof message === 'string');
        }
        return [];
    } catch (error) {
        console.error('Error extracting warn_case messages:', error);
        return [];
    }
};

/**
 * Formats an array of messages with proper grammar (using "and" before the last item)
 * 
 * @param {Array} messages - Array of message strings
 * @returns {string} Formatted string with proper grammar
 */
export const formatMessagesWithAnd = (messages) => {
    if (!messages || !Array.isArray(messages) || messages.length === 0) {
        return '';
    }

    if (messages.length === 1) {
        return messages[0];
    }

    if (messages.length === 2) {
        return messages.join(' and ');
    }

    // For 3 or more items: "item1, item2, item3 and item4"
    return messages.slice(0, -1).join(', ') + ' and ' + messages[messages.length - 1];
};